import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { restApi } from '../../services/Api'
import { query, paginate } from '../../lib/loopback'
import { path } from 'ramda'

const cenarioRepository = createRepository({
  path: 'cenarios',
  restApi,
  queryTransform: {
    valorInicialDe: query.gteValue('valorInicial'),
    valorInicialAte: query.lteValue('valorInicial'),
    valorFinalDe: query.gteValue('valorFinal'),
    valorFinalAte: query.lteValue('valorFinal'),
    rescoId: query.likeDigits('riscoId'),
    descricao: query.ilikeWithoutSplit('descricao'),
    ...paginate
  },
  getErrorMessage: response => path(['data', 'error', 'message'], response)
})

cenarioRepository.listBySolicitacao = ({
  statusSolicitacao,
  idSolicitacao,
  value,
  order,
  limit
}) => {
  const where = {
    descricao: value
      ? {
          like: `%${value}%`
        }
      : undefined
  }

  const filter = {
    order,
    where,
    limit
  }

  return restApi.get(
    `cenarios/solicitacao/${idSolicitacao}/${statusSolicitacao}`,
    { filter }
  )
}

export { cenarioRepository }
